/**
 * Use cases API slice.
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 *
 * Powers the public SEO pages at /use-cases and /use-cases/[slug].
 */
import { fetchWithAuth } from './client';

function publicResponse(data) {
  return {
    ...data,
    ...(data?.useCases ? { useCases: data.useCases } : {}),
    ...(data?.useCase ? { useCase: data.useCase } : {}),
    ...(data?.relatedUseCases ? { relatedUseCases: data.relatedUseCases } : {}),
  };
}

export const useCasesApi = {
  list: async ({ summary = false } = {}) => publicResponse(await fetchWithAuth(`/json/use-cases${summary ? '?summary=1' : ''}`)),

  getBySlug: async (slug) => {
    return publicResponse(await fetchWithAuth(`/json/use-cases/${encodeURIComponent(slug)}`));
  },
};
